import React from 'react'
import type { NativeStackScreenProps } from '@react-navigation/native-stack'
import { useDispatch } from 'APP/Hooks/redux'
import { Trans } from 'react-i18next'
import styled from 'styled-components/native'
import { SafeAreaView } from 'react-native-safe-area-context'

import Config from 'APP/Config'
import { handlePressContactSupport } from 'APP/Helpers/handlePressContactSupport'
import PatientActions from 'APP/Redux/PatientRedux'
import I18n from 'APP/I18n'

import NoticeBarContainer from 'APP/Components/NoticeBarContainer'
import List from 'APP/Components/List'
import ListItem from 'APP/Converse/ListItem'
import Typography from 'APP/Converse/Typography'
import { ResponsiveView } from 'APP/Converse/Layout'

export type ChangeEmailConfirmationScreenProps = NativeStackScreenProps<
  ReactNavigation.RootParamList,
  'changeEmailConfirmation'
>

const ScreenContainer = styled(SafeAreaView).attrs({
  edges: ['bottom', 'left', 'right'],
})`
  flex: 1;
`

const ContentContainer = styled(ResponsiveView)`
  gap: ${({ theme }) => theme.metrics.baseMargin * 2}px;
  padding: ${({ theme }) => theme.metrics.baseMargin}px;
`

const ChangeEmailConfirmationScreen = ({ route }: ChangeEmailConfirmationScreenProps) => {
  const { email } = route.params
  const dispatch = useDispatch()

  const onClickResend = () => {
    dispatch(PatientActions.patientEmailChangeRequest(email, true))
  }

  return (
    <NoticeBarContainer>
      <ScreenContainer>
        <ContentContainer>
          <Typography variant="h1">{I18n.t('ChangeEmailConfirmationScreen.title')}</Typography>
          <Typography variant="bodyNormal" testID="EMAIL_CONFIRMATION_DESCRIPTION">
            <Trans
              i18n={I18n}
              i18nKey="ChangeEmailConfirmationScreen.description"
              values={{ email }}
              components={[
                <Typography variant="bodyNormalBold" key="email">
                  {''}
                </Typography>,
              ]}
            />
          </Typography>
          <List>
            <ListItem
              key="resend"
              testID="RESEND_EMAIL_BUTTON"
              title={I18n.t('ChangeEmailConfirmationScreen.resend')}
              onPress={onClickResend}
            />
            <ListItem
              key="support"
              testID="CONTACT_SUPPORT_BUTTON"
              title={I18n.t('ChangeEmailConfirmationScreen.support.title')}
              subtitle={I18n.t('ChangeEmailConfirmationScreen.support.subtitle')}
              onPress={handlePressContactSupport}
              iconName={Config.CUSTOM_SUPPORT_PAGE ? 'chevron-right' : 'exit-to-app'}
            />
          </List>
        </ContentContainer>
      </ScreenContainer>
    </NoticeBarContainer>
  )
}

export default ChangeEmailConfirmationScreen
